import React,{Component} from 'react';
import './dashboard.css'
import {Card} from 'semantic-ui-react'
import { Col, Row, Fade } from 'reactstrap';
import Cookies from "js-cookie";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import axiosTags from "../../../axios/axios_tag";
import * as common from "../../../const/Common/CommonFunc";
import PlaceHolder from "../../../components/PlaceHolder/PlaceHolder";
import apiConfig from "../../../axios/axios_api_services";

let date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

class App extends Component{

  state = {
    spin:true,
    dashboards: []
  };

  componentWillMount(){
    let user_obj = Cookies.get("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
    this.props.userHandler(JSON.parse(user_obj));
  }

  getAllDashboards = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.CORPORATE_DASHBOARD(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let result = response.data.dashboardCards;
          this.setState({
            dashboards: result,
            spin: false
          });

          const data = {branchCount: 0, departmentCount: 0, buildingsCount: 0};
          if (result && result.length !== 0) {
            result.map((obj, index) => {
              if (obj.name.indexOf("Departments") !== -1) {
                data.departmentCount = obj.count
              }
              if (obj.name.indexOf("Branches") !== -1) {
                data.branchCount = obj.count
              }
              if (obj.name.indexOf("Buildings") !== -1) {
                data.buildingsCount = obj.count
              }
            })
          }
          const obj = {
            branchCount: data.branchCount,
            departmentCount: data.departmentCount,
            buildingsCount: data.buildingsCount,
          };
          this.props.addTagsDashboard(obj);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDashboards();
        }
      });
  };

  componentDidMount(){
    this.getAllDashboards();
  }

  render() {
    // const {tagsDashboard} = this.props;
    const {dashboards} = this.state;

    return (
      <div className="animated fadeIn">

        <Row>

          {
            dashboards.length !== 0 ?
              dashboards.map((element, index) => (

                <Col className={"marginBottom"} key={index} sm={12} md={12} lg={4} xl={4}>
                  <Card
                    fluid
                    color={"yellow"}
                    link
                    header={element.name}
                    meta={"Number Of All "+element.name}
                    description={element.count}
                    extra={date}

                  />
                </Col>
              ))
              : <PlaceHolder data={[1,2,3]}/>
          }

        </Row>

      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  custom_visitors_list: state.reception_SheduleMeetingReducer.custom_visitors_list,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  usr_obj: state.userReducer.user,
  tagsDashboard: state.COPAdminReducer.tagsDashboard
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
    // dashboard details handler
    addTagsDashboard: (data) => dispatch(actionCreator.addTagsDashboard(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
